<template>
  <div class="row">
    <f-widget-list
      :item="item"
      @change="change"
      @error="handleError"
      :fields="fields"
      :design="design"
      :disabled="disabled"
      :selector="selector"
      :form-state="formState"
      :form-context="formContext"
      @fields-change="fieldsChanged"
      @on-validation="on_valid"
    ></f-widget-list>

    <div class="col-12 text-left px-2">
      <f-add-field
        v-if="design"
        :selector="selector"
        full
        v-model="fields"
        :form-state="formState"
        class="mt-5"
      ></f-add-field>

      <b-sidebar
        :visible="propertiesVisible"
        @change="changeShowProps"
        right
        shadow
        v-if="field"
        width="400px"
      >
        <template v-slot:title> Edit: {{ selector.field.name }} </template>
        <div class="px-3 py-2 text-left">
          <component
            :design="design"
            :field="field"
            :fields="selector.fields"
            :form-state="formState"
            :disabled="disabled"
            @change="updateField"
            @error="handleError"
            @changeProp="changeProp"
            @select="on_select_child"
            :is="selector.field.field_type + '-props'"
          />
        </div>
        <template v-slot:footer="{ hide }">
          <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
            <f-add-field
              :selector="selector"
              full
              v-if="selected_is_container"
              v-model="field.fields"
            ></f-add-field>
            <b-button @click="duplicateItem">Duplicate</b-button>

            <b-button @click="deleteItem" class="ml-auto p-2" variant="danger"
              >Delete</b-button
            >
          </div>
        </template>
      </b-sidebar>
    </div>
  </div>
</template>

<script>
import FWidget from "./widget/FWidget.vue";
import { FIELD_TYPES, FIELD_TYPES_BY_CODE } from "./field_types.js";
import OListActions from "../vue-ocom/components/table/OListActions.vue";

import CloseIcon from "vue-material-design-icons/Close.vue";
import TextProps from "./widget/text/TextProps.vue";
import NumberProps from "./widget/number/NumberProps.vue";
import MoneyProps from "./widget/money/MoneyProps.vue";
import SectionProps from "./widget/section/SectionProps.vue";
import ConditionalProps from "./widget/conditional/ConditionalProps.vue";
import WizardProps from "./widget/wizard/WizardProps.vue";
import WizardstepProps from "./widget/wizard/WizardStepProps.vue";
import FormulaProps from "./widget/formula/FormulaProps.vue";
import SelectProps from "./widget/select/SelectProps.vue";
import MultiselectProps from "./widget/multiselect/MultiSelectProps.vue";
import RepeatProps from "./widget/repeat/RepeatProps.vue";
import TableProps from "./widget/table/TableProps.vue";
import TextareaProps from "./widget/textarea/TextAreaProps.vue";
import StatichtmlProps from "./widget/statichtml/StatichtmlProps.vue";
import CheckboxProps from "./widget/checkbox/CheckboxProps.vue";
import Checkbox_text_filesProps from "./widget/yes_no_notes_files/YesNoNotesFilesProps.vue";
import DatetimeProps from "./widget/datetime/DatetimeProps.vue";
import FileuploadProps from "./widget/fileupload/FileuploadProps.vue";
import FWidgetList from "./widget/FWidgetList.vue";
import { find_new_code } from "./utils.js";
import calc_score from "./utils/calc_score.js";
import { v4 as uuidv4 } from "uuid";

export default {
  name: "FTemplate",
  components: {
    CloseIcon,
    OListActions,
    FWidget,
    FWidgetList,
    TextProps,
    NumberProps,
    MoneyProps,
    SelectProps,
    MultiselectProps,
    TextareaProps,
    CheckboxProps,
    StatichtmlProps,
    SectionProps,
    RepeatProps,
    TableProps,
    ConditionalProps,
    FormulaProps,
    DatetimeProps,
    FileuploadProps,
    WizardProps,
    WizardstepProps,
    Checkbox_text_filesProps,
  },
  model: {
    event: "change",
    prop: "item",
  },
  data() {
    var vm = this;
    return {
      fieldTypes: FIELD_TYPES,
      drawer: true,
      showProps: false,
      selector: {
        field: null,
        fields: null,
        dragging: false,
        selectThis(field, fields) {
          this.field = field;
          this.fields = fields;
          vm.showProps = true; // show Props on selected
        },
        editThis(field, fields) {
          this.field = field;
          this.fields = fields;
          vm.showProps = true;
        },
        changed() {
          vm.fieldsChanged(this.field);
        },
      },
    };
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    design: { type: Boolean, default: false },
    fields: { type: Array, default: () => [] },
    formState: {
      type: Object,
      default: () => {},
    },
    formContext: {
      type: Object,
      default: () => ({}),
    },
    disabled: { type: Boolean, default: false },
    hasScore: { type: Boolean, default: false },
    score: {
      type: Object,
      default: () => {},
    },
    workflowFields: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    handleError(msg) {
      this.$emit("error", msg);
    },
    changeProp: function () {
      this.fieldsChanged(this.fields);
    },
    updateField: function () {
      console.log("FTemplate:updateField", this.item);
      this.change(this.item);
    },
    change: function (item) {
      if (this.formState) this.formState.dirty = true;

      if (this.hasScore) {
        const score = calc_score(this.item, this.fields);
        this.$emit("update:score", score);
      }

      // Ensure everything has an id
      const vm = this;
      _.forEach(this.fields, function (fld) {
        if (!("id" in fld)) {
          vm.$set(fld, "id", uuidv4());
        }
      });

      if (this.calcFunction) {
        this.calcFunction(item);
      }
      this.$emit("change", this.item);
    },
    fieldsChanged: function (fields) {
      if (this.formState) this.formState.dirty = true;

      this.$emit("fields-change", fields);
    },
    on_select_child(field) {
      this.selector.selectThis(field, this.peer_fields);
    },
    addField(typeDef) {
      var fields = this.peer_fields;

      var newItemNo = fields.length + 1;

      var newField = {
        id: uuidv4(),
        display_order: newItemNo,
        field_type: typeDef.code,
        code: typeDef.code + "_" + newItemNo,
        name: typeDef.name + " " + newItemNo,
        params: _.cloneDeep(typeDef.params),
        value: _.cloneDeep(typeDef.value),
        has_score: false,

        _disabled: false,
        _newfield: true,
      };

      if (typeDef.container === true) {
        newField.fields = []; // init blank array
      }

      fields.push(newField);

      if (this.formState) this.formState.dirty = true;

      this.$emit("fields-change", fields);

      this.selector.selectThis(newField, fields);
      this.dialog = true; // show Edit!
    },
    changeShowProps(value) {
      // from b-sidebar
      if (this.design) {
        this.showProps = value;
      } else {
        this.showProps = false;
      }
    },
    toggleShowProps() {
      if (this.selector.field) {
        this.selector.field._show_props = !(
          this.selector.field._show_props || false
        );
      }
    },
    select_page($event) {
      this.selector.selectThis(null, null); //nothing
    },
    close_dialog() {
      if (this.selector.field) {
        delete this.selector.field["_newfield"]; // remove this as it's no longer new!
      }

      this.dialog = false;
    },
    duplicateItem() {
      var newField = _.cloneDeep(this.selector.field);

      newField.id = uuidv4();

      const newCode = find_new_code(newField.code, this.selector.fields);
      newField.code = newCode;

      this.selector.fields.push(newField);
      this.selector.editThis(newField, this.selector.fields);
    },
    deleteItem() {
      const index = this.selector.fields.indexOf(this.selector.field);
      if (index >= 0) {
        this.selector.fields.splice(index, 1);
        this.selector.field = null;
        this.showProps = false;
        this.change(this.item); // changed
      }
    },
    on_valid(value) {
      this.$emit("on-validation", value);
    },
  },
  computed: {
    peer_fields() {
      var fields = this.selector.fields;

      if (fields == null) {
        fields = this.fields; // root
      }

      if (this.selector.field && "fields" in this.selector.field) {
        fields = this.selector.field.fields;
      }

      return fields;
    },
    propertiesVisible() {
      if (this.design && this.field != null) {
        return this.showProps;
      }

      return false;
    },
    field() {
      return this.selector.field;
    },
    selected_index() {
      if (this.field && this.selector.fields) {
        return this.selector.fields.indexOf(this.field);
      }

      return -1;
    },
    field_type_list() {
      return _.sortBy(_.filter(FIELD_TYPES, "show"), "name");
    },
    selected_is_container() {
      if (this.field) {
        return FIELD_TYPES_BY_CODE[this.field.field_type].container;
      } else {
        return false;
      }
    },
  },
  created() {
    if (!this.item) {
      this.change({}); // init to empty object
    }
  },
};
</script>

<style scoped>
.design {
  border: 2px dotted lightblue;
}
.selected {
  border: silver 1px solid;
  background-color: rgba(140, 210, 255, 0.45);
}
.footer {
  position: fixed;
  left: 0px;
  top: 40px;
}
</style>
